import "./AIContextModal.scss";

import Button from "../Button";
import Modal from "../Modal";

const AIContextModal = ({
  isVisible,
  close,
  setSuggestedValue,
  additionalUserContext,
  setAdditionalUserContext,
  fetchSuggestedResponse,
  resetMessage
}) => {
  const handleRegenerate = async () => {
    close();

    if (await fetchSuggestedResponse()) {
      resetMessage();
      setSuggestedValue();
    }
  };

  const handleRestore = () => {
    setSuggestedValue();
    close();
  };

  return (
    <>
      {isVisible && (
        <Modal
          title="Re-generate AI suggestion with additional context"
          withCloseButton={true}
          close={close}
        >
          <div className="AIContextModal__content">
            <div>
              <textarea
                value={additionalUserContext ?? ""}
                onChange={e => setAdditionalUserContext(e.target.value)}
                placeholder="Input additional context"
              />
            </div>
            <div className="AIContextModal__buttons">
              <Button
                onClick={handleRestore}
                buttonType="negative"
                message="Restore current suggestion"
                className="AIContextModal__button"
              />
              <Button
                onClick={handleRegenerate}
                buttonType="positive"
                message="Re-generate AI suggestion"
                className="AIContextModal__button"
                data-testid="regenerate-button"
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AIContextModal;
